export interface Scope {
  id: number;
  name: string;
}

export enum ScopeType {
  None = "none",
  Role = "role",
  CreatedByUser = "createdByUser",
  AssignedToUser = "assignedToUser",
}

export enum ScopeIDMap {
  None = 0,
  Role = 1,
  CreatedByUser = 2,
  AssignedToUser = 3,
}

export const SCOPES = [
  { id: ScopeIDMap.Role, name: ScopeType.Role },
  { id: ScopeIDMap.CreatedByUser, name: ScopeType.CreatedByUser },
  { id: ScopeIDMap.AssignedToUser, name: ScopeType.AssignedToUser },
];
